<template>
  <el-card
    class="settings"
    shadow="never">
    <div
      slot="header"
      class="settings-header">
      图片导航 <el-button
        type="danger"
        style="margin-left: 8px;"
        @click="deleteitem">删除</el-button>
    </div>
    <el-form
      ref="form"
      :model="slide"
      label-position="top"
      label-width="100px">
      <el-form-item
        label="布局："
        prop="layoutType">
        <el-radio-group v-model="slide.layoutType">
          <el-radio-button :label="1">一行一个</el-radio-button>
          <el-radio-button :label="2">一行二个</el-radio-button>
          <el-radio-button :label="3">一行三个</el-radio-button>
          <!-- <el-radio-button :label="4">一行四个</el-radio-button> -->
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="内容配置："
        prop="graphics">
        <el-button
          type="primary"
          style="margin-bottom: 8px;"
          @click="addMessages">添加</el-button>
        <el-table
          border
          :data="slide.graphics">
          <el-table-column
            label="首图"
            width="300"
            :resizable="false"
            prop="">
            <template slot-scope="{$index}">
              <el-form-item
                label-width="0"
                :prop="'graphics.'+$index + '.image'"
                :rules="[{ required: true, message: '请上传图片', trigger: 'change' }]">
                <upload-with-crop
                  v-model="slide.graphics[$index].image"
                  :showTip="false"
                  :limit="1"
                  :autoCropWidth="240"
                  :autoCropHeight="240" />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            :resizable="false"
            width="100"
            label="链接类型"
            prop="linkType">
            <template slot-scope="{row, $index}">
              <el-form-item
                label-width="0"
                :prop="'graphics.'+$index + '.linkType'"
                :rules="[{ required: false, message: '请选择链接', trigger: 'change' }]">
                {{ row.linkType | linkTypeName() }}
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            :resizable="false"
            label="链接内容"
            prop="title">
            <template slot-scope="{row}">
              <el-form-item label-width="0">
                {{ row.title }}
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            :resizable="false"
            label="操作"
            width="95">
            <template slot-scope="{row, $index }">
              <el-dropdown>
                <el-button
                  type="info">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu
                  slot="dropdown">
                  <el-dropdown-item
                    @click.native="selectitem(row, $index)">选择链接</el-dropdown-item>
                  <el-dropdown-item
                    @click.native="deleterowitem($index)">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <el-button
                type="primary"
                @click="selectitem(row, $index)">选择链接</el-button>
              <el-button
                type="danger"
                @click="deleterowitem($index)">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-alert
        title="只能上传image/*,.mp4.webm.ogg文件，且图片不超过2M，视频不超过10M，建议上传相同宽高比的图片文件。"
        :closable="false"
        type="warning">
      </el-alert>
    </el-form>
    <content-select-modal
      ref="select"
      @handleSelect="handleSelect" />
  </el-card>
</template>

<script>
// import _ from 'lodash'
import { mapState } from 'vuex'
import UploadWithCrop from '@/components/wx/upload-image-new.vue'
import ContentSelectModal from '../content-select-modal.vue'
// const MAX_LENGTH = 5
export default {
  name: 'WeCircular',
  components: { UploadWithCrop, ContentSelectModal }, // draggable, ContentCard
  props: {
    value: {
      type: Object,
      default() {
        return {
          componentName: 'pictureadv',
          layoutType: 1,
          graphics: [],
          visible: false
        }
      }
    },
    index: Number
  },
  data() {
    return {
      visible: false,
      dragOptions: {
        animation: 0,
        disabled: false,
        group: 'description',
        ghostClass: 'ghost'
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    }),
    slide: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  methods: {
    deleteitem() {
      this.$emit('deleteItem', this.index)
    },
    selectitem(row, $index) {
      console.log(row, $index)
      this.$refs.select.init(row, $index)
    },
    handleSelect(info, index) {
      this.$set(this.slide.graphics, index, {
        ...this.slide.graphics[index],
        ...info
      })
    },
    deleterowitem(index) {
      this.slide.graphics.splice(index, 1)
    },
    addMessages() {
      this.slide.graphics.push({
        title: '',
        image: [],
        linkType: 15,
        link: null // 等同id
      })
    },
    submit() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate(v => {
          if (v) {
            resolve()
          } else {
            reject(new Error(JSON.stringify({ index: this.index })))
          }
        })
      })
    }
  }
}
</script>
